import { usePaymentInvoicesTableStore } from 'store/paymentInvoicesTable';
import { usePaymentInvoicesTableFiltersStore } from 'store/paymentInvoicesTableFilters';
import Table from 'ui/Table/Table';
import { errorHelper } from 'utils/helpers/errorHelper';
import type { TComponent } from 'utils/types/component';

import { useOnce } from 'components/utils/hooks/useOnce';

import { CustomPagination } from './components/Paginations';
import { getColumns } from './columns';
import styles from './EditSettingsTable.module.scss';

export const EditSettingsTable: TComponent = () => {
    const getPaymentReports = usePaymentInvoicesTableStore('getPaymentReports');
    const updatePaymentReportEnabled = usePaymentInvoicesTableStore(
        'updatePaymentReportEnabledAndRefresh',
    );
    const deletePaymentReport = usePaymentInvoicesTableStore(
        'deletePaymentReportAndRefresh',
    );
    const paymentReports = usePaymentInvoicesTableStore('paymentReports');
    const isLoading = usePaymentInvoicesTableStore('isReportsLoading');
    const params = usePaymentInvoicesTableFiltersStore('reportsParams');

    useOnce(
        () => true,
        () => {
            getPaymentReports(params);
        },
        [],
    );

    const handleToggleEnabled = async (identity: string, checked: boolean) => {
        try {
            await updatePaymentReportEnabled(identity, checked, params);
        } catch (error) {
            errorHelper.showApiErrorNotification(error);
        }
    };

    const handleDeleteReport = (identity: string) => {
        deletePaymentReport(identity, params);
    };

    const tableColumns = getColumns(handleToggleEnabled, handleDeleteReport);

    return (
        <div className={styles.tableContainer}>
            <Table
                loading={isLoading}
                tableRows={paymentReports}
                columns={tableColumns}
                onChange={() => {}}
                tableLayout='fixed'
                rowKey={(record) => record.identity}
                scroll={{ x: 'max-content' }}
                isResizable
            />
            <div className={styles.tableBottom}>
                <CustomPagination />
            </div>
        </div>
    );
};
